import {
  BeListApiAddNewTag,
  BeListApiGetAllTags,
  BeListApiGetList,
  beListGetUserColumns,
  beListPutSenderInfo,
  beListUpdateUserColumns
} from 'Api/BeListApi'

import { beMessApiGenerateThumbnail } from 'Api/BeMessApi'

import {
  beABTestCheckScheduleAbTestById,
  beABTestGetABTestConfigById,
  beABTestGetAsycQueueConfId,
  beABTestGetGlobalStatus,
  beABTestSaveABTestConfig,
  beABTestScheduleAbTestById,
  beABTestStartProcessAbTest,
  beABTestUpdateABTestConfig
} from 'Api/beABTestApi'

import {
  beEmailMessageApiGetEntitiesThatUseMessage,
  beEmailMessageApiGetMessageDetailsLazy
} from 'Api/beEmailMessageApi'

import { beSendGoSendingsLimits } from 'Api/beSendGoApi'

import {
  beRecipientGetDynamicFieldsDefinition,
  beRecipientGetListOfGroupDetails,
  beRecipientGetTestsDefault,
  beRecipientSearchForRecipients,
  CHANNEL_TYPE_EMAIL,
  GROUPS_SEARCH_TYPE_ECONTAINS,
  HAS_RECIPIENTS,
  SUBSCRIPTION_TYPE_SUBSCRIBED
} from 'Api/beRecipientApi'

import { bePecPlusGetPecPlusConfig } from 'Api/bePecPlusApi'

import { beAccountSettingsNotifyQueueing } from 'Api/beAccountSettingsApi'
import { beAsyncTrackingApiCheckTrackingDomainIsCustomizable } from 'Api/beAsyncTracking'
import { beEmailCheckupFastMessageCheck } from 'Api/beEmailCheckupApi'
import {
  beFiltersGetListOfCategories,
  beFiltersGetListOfFilters
} from 'Api/beFiltersApi'
import {
  BEQUEUE_CONFIG_ACTION_MAIL,
  BEQUEUE_CONFIG_EXCLUDE,
  BEQUEUE_CONFIG_FILTER_COND_AND,
  BEQUEUE_CONFIG_FILTER_COND_OR,
  BEQUEUE_CONFIG_INCLUDE,
  BEQUEUE_CONFIG_TYPE_EVERYBODY,
  BEQUEUE_CONFIG_TYPE_GROUPS,
  beQueueExecuteConfigurationProcessing,
  beQueueGetConfigurationById,
  beQueueSaveQueueingConfiguration,
  beQueueSimulateConfigurationProcessing
} from 'Api/beQueueApi'
import {
  ENTITY_TYPE_AUTOMATION_WORKFLOW,
  ENTITY_TYPE_TRIGGER,
  LOGIN_TYPE_ADM,
  LOGIN_TYPE_ADMLIMITED,
  MATCH_FILTER_CONDITION_ALL
} from 'Constants/'
import {
  CUSTOM_DOMAIN_CUSTOMIZABLE,
  CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
} from 'Constants/index'
import getIntl from 'Helpers/intl'
import {
  GROUP_TYPE_TEST,
  RECIPIENTS_TEST_GROUP
} from 'Pages/AbTestWizard/const'
import {
  evalCondition,
  STORE_KEY_ID_LIST,
  STORE_KEY_LOGIN_TYPE,
  storeGet
} from 'mailup-react-helpers'

import { PARAM_ORDER_DESC } from 'mailup-web-components'

export async function getAllTags() {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))

  const result = await BeListApiGetAllTags(idList)
  return result
}

export async function addNewTag(pTagName) {
  const idList = parseInt(storeGet(STORE_KEY_ID_LIST))
  const result = await BeListApiAddNewTag(idList, pTagName)
  return result
}

export async function fetchEmailEntitiesThatUseMessage(idMessage) {
  const ret = await beEmailMessageApiGetEntitiesThatUseMessage(idMessage)
  return ret
}

export async function getABTestConfigByIdAction(idABTest) {
  const ret = await beABTestGetABTestConfigById(idABTest)
  return ret
}

export async function getMessageDetailsAction(id) {
  const ret = await beEmailMessageApiGetMessageDetailsLazy(id)
  return ret
}

export async function saveABTestConfigAction(data) {
  const ret = await beABTestSaveABTestConfig(data)
  return ret
}

export async function updateABTestConfigAction(data) {
  const ret = await beABTestUpdateABTestConfig(data)
  return ret
}

export async function generateThumbnailAction(idMessage) {
  const ret = await beMessApiGenerateThumbnail(idMessage)
  return ret
}

export async function fastCheck(idMessage) {
  const checks = {
    Checks: [
      'Size',
      'MaxSize',
      'Attachments',
      'DynamicContents',
      'LinksWoTracking',
      'UnsubscribeLink',
      'Fields',
      'Preheader',
      'WebAnalytics',
      'LiquidCode',
      'Links',
      'Content'
    ]
  }

  const {
    CheckLiquidCode,
    CheckAttachments,
    CheckDynamicContents,
    CheckSize,
    CheckBlacklistResult,
    CheckLinksWoTracking,
    CheckUnsubscribeLink,
    CheckFields,
    CheckMaxSize,
    CheckPreheader,
    CheckWebAnalytics,
    CheckContent
  } = await beEmailCheckupFastMessageCheck(idMessage, checks)

  let domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  try {
    const resultDomainIsCustomizable = await beAsyncTrackingApiCheckTrackingDomainIsCustomizable()
    const domainIsCustomizableOermission = evalCondition(
      'uo:GEST AND uo:SETTINGS'
    )
    if (resultDomainIsCustomizable && domainIsCustomizableOermission) {
      domainCustomizableStatus = resultDomainIsCustomizable.IsCustomizable
    }
  } catch (error) {
    domainCustomizableStatus = CUSTOM_DOMAIN_NOT_CUSTOMIZABLE
  }

  const entities = await beEmailMessageApiGetEntitiesThatUseMessage(idMessage)

  const workflows = entities.filter(
    ({ Type }) =>
      Type === ENTITY_TYPE_TRIGGER || Type === ENTITY_TYPE_AUTOMATION_WORKFLOW
  )

  const wrongDynamicTags = CheckFields.WrongDynamicTags.map(({ Value }) =>
    Value.replace(/[[\]]/g, '')
  ).filter(f => f !== '')

  const blocking =
    Number(!CheckLiquidCode) +
    Number(!CheckAttachments.Check) +
    Number(!CheckDynamicContents.Check) +
    Number(!CheckSize.Check) +
    Number(CheckBlacklistResult.Action === 2) +
    Number(CheckContent.Action === 2)

  const potential =
    Number(!CheckLinksWoTracking) +
    Number(!CheckUnsubscribeLink) +
    Number(!CheckMaxSize.Check) +
    Number(CheckBlacklistResult.Action === 1) +
    Number(wrongDynamicTags.length > 0) +
    Number(workflows.length > 0)

  const improvements =
    Number(!CheckPreheader) +
    Number(!CheckWebAnalytics) +
    Number(domainCustomizableStatus === CUSTOM_DOMAIN_CUSTOMIZABLE)

  return {
    blocking,
    potential,
    improvements,
    idMessage
  }
}

export async function getAccountSendingLimits() {
  const result = beSendGoSendingsLimits()
  return result
}

export async function fetchSenderInfo() {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const [pecConfig, listConfig] = await Promise.all([
    bePecPlusGetPecPlusConfig(idList),
    BeListApiGetList(idList)
  ])

  const isPEC = !!pecConfig

  const listReplyTo = listConfig.SenderReplyTo
    ? listConfig.SenderReplyTo
    : listConfig.BouncedEmail

  return {
    isPEC,
    pecPlusStatus: pecConfig ? pecConfig.Status : undefined,
    // queueStatus: asyncQueueConfig ? asyncQueueConfig.State : undefined,
    // idAsyncQueueConfig: asyncQueueConfig ? asyncQueueConfig.Id : undefined,
    // queued: lastSending && lastSending.Queued ? lastSending.Queued : undefined,
    senderName: listConfig.SenderName,
    senderEmail: listConfig.SenderEmail,
    replyToEmail: listReplyTo,
    customSender: false
    // idFieldSenderNameMail: senderFromLastSending
    //   ? lastSending.idFieldSenderNameMail
    //   : undefined,
    // idSenderEmailField: senderFromLastSending
    //   ? lastSending.IdSenderEmailField
    //   : undefined,
    // lastSendingId: lastSending && lastSending.Id ? lastSending.Id : undefined,
    // sendingOrScheduleId:
    //   lastSending && lastSending.Id ? lastSending.Id : undefined
  }
}

export async function getRecipientTestsDefault() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beRecipientGetTestsDefault(idList)
  return result
}

export async function getDynamicFields() {
  const fields = beRecipientGetDynamicFieldsDefinition({
    isdynamic: true
  })
  return fields
}

export async function getUserColumns() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const res = await beListGetUserColumns(idList)

  return res.Columns
}

export async function putBeListSenderInfo(data) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const result = beListPutSenderInfo(idList, data)
  return result
}

export async function getFilters() {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const loginType = storeGet(STORE_KEY_LOGIN_TYPE)
  const hidden =
    loginType !== LOGIN_TYPE_ADM && loginType !== LOGIN_TYPE_ADMLIMITED
      ? false
      : undefined

  const categories = await beFiltersGetListOfCategories({
    pageSize: 0,
    pageNumber: 1,
    orderBy: 'Name',
    orderDescending: false
  })

  const allCategories = [
    {
      Id: 0,
      Name: getIntl().formatMessage({ id: 'Load.Filters.WithoutCategory' })
    },
    ...categories.Items
  ]

  const allFilters = (
    await beFiltersGetListOfFilters(idList, {
      pageSize: 0,
      pageNumber: 1,
      orderBy: 'Name',
      orderDescending: false,
      hidden
    })
  ).Items

  const result = {
    optionGroups: allCategories
      .map(({ Id, Name }) => ({
        id: Id,
        label: Name,
        values: allFilters
          .filter(({ Category }) => Category === Id)
          .map(({ Id }) => Id)
      }))
      .filter(({ values }) => values.length > 0),
    options: allFilters.map(({ Id, Name, Type, Description }) => ({
      label: `${Id} - ${Name}`,
      value: Id,
      type: Type,
      description: Description,
      name: Name
    }))
  }

  return result
}

export async function getGroupsDetails(recipients) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const { Items } = await beRecipientGetListOfGroupDetails(idList, {
    orderBy: 'Id',
    orderDescending: true,
    pageNumber: 1,
    pageSize: 0,
    searchType: GROUPS_SEARCH_TYPE_ECONTAINS,
    groupType:
      recipients === RECIPIENTS_TEST_GROUP ? GROUP_TYPE_TEST : undefined,
    hasRecipients: HAS_RECIPIENTS
  })

  return Items.map(({ Id, Name, Notes }) => ({
    label: Notes ? `${Id} - ${Name} (${Notes})` : `${Id} - ${Name}`,
    value: Id
  }))
}

export async function simulatePreview(
  withParams = false,
  IdInvio,
  idABTest,
  includeGroups,
  excludeGroups,
  selectedFilters,
  typeAppliedFilters
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  let config = {
    IdList: idList,
    IdAbTest: idABTest,
    IdInvio, // prima volta === 0 dopo è diverso da 0
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_GROUPS
  }

  if (withParams) {
    config = {
      ...config,
      FiltersConditionRule:
        typeAppliedFilters === MATCH_FILTER_CONDITION_ALL
          ? BEQUEUE_CONFIG_FILTER_COND_AND
          : BEQUEUE_CONFIG_FILTER_COND_OR,
      AsyncQueueFilter: selectedFilters.map(IdFilter => ({ IdFilter })),
      AsyncQueueGroup: [
        ...includeGroups.map(IdGroup => ({
          IdGroup,
          Action: BEQUEUE_CONFIG_INCLUDE
        })),
        ...excludeGroups.map(IdGroup => ({
          IdGroup,
          Action: BEQUEUE_CONFIG_EXCLUDE
        }))
      ]
    }
  }

  const result = await beQueueSimulateConfigurationProcessing(config)

  return result
}

export async function searchForRecipients(searchCriteria, recipientsDataTable) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const pageNumber = 1
  const pageSize = 10
  const orderDescending = recipientsDataTable.sortOrder === PARAM_ORDER_DESC
  const orderBy = recipientsDataTable.sortBy

  const searchParams = {
    channel: CHANNEL_TYPE_EMAIL,
    status: [SUBSCRIPTION_TYPE_SUBSCRIBED],
    pageSize,
    pageNumber,
    orderDescending,
    orderBy
  }

  const {
    includeGroups,
    excludeGroups,
    selectedFilters,
    typeAppliedFilters
  } = searchCriteria

  const searchConditions = {
    IncludeGroups: [...includeGroups],
    ExcludeGroups: [...excludeGroups],
    MatchingFilters: selectedFilters.length
      ? { Condition: typeAppliedFilters, Filters: [...selectedFilters] }
      : undefined
  }

  const apiParams = new Map()
  apiParams.set('idList', idList)
  apiParams.set('searchParams', searchParams)
  apiParams.set('searchConditions', searchConditions)

  const res = await beRecipientSearchForRecipients(...apiParams.values())

  return res
}

export async function updateUserColumns(value) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const res = await beListUpdateUserColumns(idList, value)
  return res
}

export async function notifyQueueing(senderEmail) {
  const idList = storeGet(STORE_KEY_ID_LIST)

  const data = {
    IdList: idList,
    Sender: senderEmail
  }

  const result = await beAccountSettingsNotifyQueueing(data)

  return result
}

export async function saveQueueingConfiguration(
  idABTest,
  IdInvio,
  includeGroups,
  excludeGroups,
  selectedFilters,
  typeAppliedFilters
) {
  const idList = storeGet(STORE_KEY_ID_LIST)
  const config = {
    IdList: idList,
    IdAbTest: idABTest,
    IdInvio, // prima volta === 0 dopo è diverso da 0
    Action: BEQUEUE_CONFIG_ACTION_MAIL,
    Type: BEQUEUE_CONFIG_TYPE_EVERYBODY,
    FiltersConditionRule:
      typeAppliedFilters === MATCH_FILTER_CONDITION_ALL
        ? BEQUEUE_CONFIG_FILTER_COND_AND
        : BEQUEUE_CONFIG_FILTER_COND_OR,
    AsyncQueueFilter: selectedFilters.map(IdFilter => ({ IdFilter })),
    AsyncQueueGroup: [
      ...includeGroups.map(IdGroup => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_INCLUDE
      })),
      ...excludeGroups.map(IdGroup => ({
        IdGroup,
        Action: BEQUEUE_CONFIG_EXCLUDE
      }))
    ]
  }

  const result = await beQueueSaveQueueingConfiguration(config)
  return result
}

export async function processQueueingConfiguration(idConf) {
  const result = await beQueueExecuteConfigurationProcessing(idConf)
  return result
}

export async function startProcessAbTestAction(idAbTest, data) {
  const result = await beABTestStartProcessAbTest(idAbTest, data)
  return result
}

export async function getQueueConfiguration(idConf) {
  const result = await beQueueGetConfigurationById(idConf)
  return result
}

export async function getBeABTestGetGlobalStatus(idAbTest) {
  const result = await beABTestGetGlobalStatus(idAbTest)
  return result
}

export async function getBeABTestGetAsycQueueConfId(idAbTest) {
  const result = await beABTestGetAsycQueueConfId(idAbTest)
  return result
}

export async function checkScheduleAbTestByIdAction(
  idAbTest,
  internalTimezoneCode,
  data
) {
  const result = await beABTestCheckScheduleAbTestById(
    idAbTest,
    internalTimezoneCode,
    data
  )
  return result
}

export async function scheduleAbTestByIdAction(
  idAbTest,
  internalTimezoneCode,
  data
) {
  const result = await beABTestScheduleAbTestById(
    idAbTest,
    internalTimezoneCode,
    data
  )
  return result
}
